import { useLang } from "@/i18n/LanguageContext";
import logo from "@/assets/tribeo-logo.svg";
import { Link } from "react-router-dom";
import { track, REGISTER_URL, LOGIN_URL } from "@/lib/analytics";

const Footer = () => {
  const { t, lang, setLang } = useLang();

  return (
    <footer className="border-t border-border bg-background">
      <div className="container py-16 grid gap-10 md:grid-cols-5">
        <div className="md:col-span-2">
          <img src={logo} alt="Tribeo" className="h-7 w-auto" />
          <p className="mt-4 text-sm text-muted-foreground max-w-sm">{t.footer.tagline}</p>
          <p className="mt-2 text-xs text-muted-foreground max-w-sm">{t.trust.availability}</p>
          <div className="mt-6 flex flex-wrap gap-2">
            <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer" onClick={() => track("register_click", "footer")}
              className="inline-flex items-center rounded-full bg-primary text-primary-foreground px-4 py-2 text-xs font-bold">
              {t.footer.register}
            </a>
            <a href={LOGIN_URL} target="_blank" rel="noopener noreferrer" onClick={() => track("login_click", "footer")}
              className="inline-flex items-center rounded-full border border-border px-4 py-2 text-xs font-bold">
              {t.footer.login}
            </a>
          </div>
          <div className="mt-6 inline-flex items-center rounded-full border border-border p-0.5 text-xs font-bold">
            <button onClick={() => setLang("nl")} className={`px-3 py-1 rounded-full ${lang === "nl" ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>Nederlands</button>
            <button onClick={() => setLang("en")} className={`px-3 py-1 rounded-full ${lang === "en" ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>English</button>
          </div>
        </div>

        <div>
          <div className="text-sm font-bold">{t.footer.product}</div>
          <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
            <li><Link to={lang === "en" ? "/en/for-agents" : "/voor-makelaars"} className="hover:text-foreground">{t.solutionsNav.broker}</Link></li>
            <li><Link to={lang === "en" ? "/en/for-vendors" : "/voor-leveranciers"} className="hover:text-foreground">{t.solutionsNav.supplier}</Link></li>
            <li><Link to={lang === "en" ? "/en/home-advisor" : "/wooncoach"} className="hover:text-foreground">{lang === "en" ? "For buyers, sellers & owners" : "Voor kopers, verkopers en eigenaren"}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-bold">{t.footer.company}</div>
          <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
            <li><Link to={lang === "en" ? "/en/about" : "/about"} className="hover:text-foreground">{t.footer.about}</Link></li>
            <li><Link to={lang === "en" ? "/en/faq" : "/faq"} className="hover:text-foreground">{lang === "nl" ? "Veelgestelde vragen" : "FAQ"}</Link></li>
            <li><Link to={lang === "en" ? "/en/contact" : "/contact"} className="hover:text-foreground">{t.footer.contact}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-bold">{t.footer.legal}</div>
          <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
            <li><Link to={lang === "en" ? "/en/privacy" : "/privacy"} className="hover:text-foreground">{t.footer.privacy}</Link></li>
            <li><Link to={lang === "en" ? "/en/terms" : "/terms"} className="hover:text-foreground">{t.footer.terms}</Link></li>
            <li><Link to={lang === "en" ? "/en/cookies" : "/cookies"} className="hover:text-foreground">{t.footer.cookies}</Link></li>
            <li><Link to={lang === "en" ? "/en/security" : "/security"} className="hover:text-foreground">{t.footer.security}</Link></li>
            <li><Link to={lang === "en" ? "/en/dpa" : "/dpa"} className="hover:text-foreground">{t.footer.dpa}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border bg-secondary/40">
        <div className="container py-8">
          <div className="text-sm font-bold">{t.footer.notTitle}</div>
          <ul className="mt-3 grid gap-2 sm:grid-cols-3 text-sm text-muted-foreground">
            {t.footer.notItems.map((item) => (
              <li key={item} className="leading-relaxed">{item}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="container py-6 text-xs text-muted-foreground">
          © {new Date().getFullYear()} TNA B.V.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
